import './footer.css'

import {useNavigate} from 'react-router-dom'
import { ABOUT_ROUTE, COPYRIGHT_POLICY_ROUTE, FAQS_ROUTE, PRIVACY_POLICY_ROUTE, SERVICE_POLICY_ROUTE } from '../../../routing/routing_constants'

export const Footer = () =>{
    const navigate = useNavigate()

    return (
        <div className="footer_body padding_top">
            <div className='flexrow_footing'>
                <div className='foot_link' onClick={e=>navigate(COPYRIGHT_POLICY_ROUTE)}>Copyright Policy</div>
                <div>|</div>
                <div className='foot_link' onClick={e=>navigate(PRIVACY_POLICY_ROUTE)} >Privacy Policy</div>
                <div>|</div>
                <div className='foot_link' onClick={e=>navigate(SERVICE_POLICY_ROUTE)} >Service Policy</div>
                <div>|</div>
                <div className='foot_link' onClick={e=>navigate(ABOUT_ROUTE)}>About Us</div>
                <div>|</div>
                <div className='foot_link' onClick={e=>navigate(FAQS_ROUTE)}>Faqs</div>
            </div>
            <div className='flexrow_footing'>
                Copyright <span>&copy;</span> {new Date().getFullYear()}
            </div>
        </div>
    )
}